<template>
  <div class="exam-uniform-schedule-student-seat-sticker">
    <div class="body">
      <template v-if="result">
        <div class="result">
          <template v-if="result.fileLink">
            <el-link :href="$contextPath(result.fileLink)"
                     :underline="false"
                     target="_blank"
                     class="el-button el-button--success el-button--mini">
              <i class="el-icon-download"></i>
              <span>下载座位标贴</span>
            </el-link>
          </template>
          <template v-else>
            <span>导出返回结果为空</span>
          </template>
        </div>
      </template>
      <template v-else>
        <template v-if="committing">
          <div class="process">
            <el-progress :percentage="stateProgress"></el-progress>
            <div class="status">{{stateText}}</div>
          </div>
        </template>
        <template v-else>
          <div class="tip">
            <i class="el-icon-warning-outline"></i>
            <span>点击“开始导出”进行座位标贴的批量导出</span>
          </div>
        </template>
      </template>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :loading="committing"
                 @click="startExport">
        <template v-if="committing">
          <span>导出中</span>
        </template>
        <template v-else>
          <span v-if="result">重新导出</span>
          <span v-else>开始导出</span>
        </template>
      </el-button>
      <el-button size="mini"
                 type="default"
                 :disabled="committing"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamUniformScheduleStudentSeatSticker',
  props: {
    extraParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      committing: false,
      stateInfo: null,
      result: null
    }
  },
  computed: {
    stateProgress () {
      const stateInfo = this.stateInfo
      if (stateInfo && typeof stateInfo.progress === 'number') {
        return stateInfo.progress
      }
      return 0
    },
    stateText () {
      const stateInfo = this.stateInfo
      if (stateInfo && stateInfo.message) {
        return stateInfo.message
      }
      return '导出中，请稍等...'
    }
  },
  methods: {
    startExport () {
      this.stateInfo = null
      this.result = null
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/exam/uniform/schedule/student/exportSeatSticker',
        method: 'post',
        data: this.$qs.stringify(this.extraParams)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.queryState()
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              this.committing = false
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
        this.committing = false
      })
    },
    queryState () {
      this.$ajax({
        url: '/workspace/manager/exam/uniform/schedule/student/seatStickerState',
        method: 'post',
        data: this.$qs.stringify(this.extraParams)
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              if (response.data.isDone) {
                this.result = response.data
                this.$nextTick(() => {
                  this.committing = false
                })
              } else {
                this.stateInfo = response.data.genStat || {}
                setTimeout(this.queryState, 1000)
              }
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              this.stateInfo = null
              this.committing = false
              break
            }
          }
        }
      }, () => {
        setTimeout(this.queryState, 1000)
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .exam-uniform-schedule-student-seat-sticker {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .body {
      flex: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      & > .result {
        font-size: 12px;
        .el-link {
          color: #fff;
        }
      }
      & > .process {
        width: 260px;
        & > .status {
          margin-top: 1px;
          color: #606266;
          font-size: 12px;
        }
      }
      & > .tip {
        font-size: 12px;
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
